
import React from "react";

interface ProgressDisplayProps {
  totalAchievement: number;
  totalTarget: number;
  totalPercentage: number;
  filterSummary: string;
}

const ProgressDisplay = ({ 
  totalAchievement, 
  totalTarget, 
  totalPercentage,
  filterSummary 
}: ProgressDisplayProps) => {
  return (
    <div className="mb-6 p-5 bg-slate-800 rounded-lg border border-slate-700">
      <div className="text-center mb-2 text-slate-300">
        Total Revenue Achievement Progress {filterSummary}
      </div>
      <div className="text-3xl text-center font-bold mb-3">
        ${totalAchievement.toLocaleString()} YTD of ${totalTarget.toLocaleString()} Target <span className="text-xl">({totalPercentage}%)</span>
      </div>
      <div className="relative overflow-hidden rounded-full h-6 bg-slate-700">
        <div className="relative h-full bg-gradient-to-r from-blue-600 to-purple-600 progress-swoosh" style={{
          width: `${totalPercentage > 100 ? 100 : totalPercentage}%`
        }}>
          <div className="absolute inset-0 flex items-center justify-center text-xs font-semibold text-white">
            {totalPercentage}%
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressDisplay;
